function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { addNotification } from "../../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, NotificationTypeEnum } from "../../../actions/ui/types";
import { DOWNLOAD_REPORT_FAILURE, DOWNLOAD_REPORT_REQUEST } from "../../../actions/types";
import { downloadReport } from "../../../actions";
import { reportsCenterErrorCodes } from "../../../config/errorCodeMessages";
export var downloadReportEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(DOWNLOAD_REPORT_REQUEST), switchMap(function(action) {
        var _action_payload;
        return from(api.reportsCenterService.downloadReport((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.downloadReportInput).pipe(mergeMap(function(response) {
            var _action_payload;
            return of(downloadReport.success(_object_spread_props(_object_spread({}, response || {}), {
                downloadType: action.payload.downloadType,
                supportingDocumentKey: (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.supportingDocumentKey
            })));
        }), catchError(function(err) {
            var _err_receivedException, _err_receivedException1;
            var _reportsCenterErrorCodes_err_receivedException_errorCode;
            return of(downloadReport.failure(err), addNotification({
                type: NotificationTypeEnum.ERROR,
                action: DOWNLOAD_REPORT_FAILURE,
                body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = reportsCenterErrorCodes[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "download_report_notifications.failure" : "download_report_notifications.failure",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        })));
    }));
};
export default downloadReportEpic;

//# sourceMappingURL=index.js.map